(function() {
    'use strict';

    angular.module("imApp").factory("stockTransferMonitorService", ['$ihttp', function ($ihttp) {
        var service = {
            init: function () {
                return $ihttp.post({
                    method: 2425,
                    parameters: {
                        state: 'init'
                    }
                });
            }
        }

        return service;
    }]);
})();
